<template>
  <div v-if="getStatsData" class="bp-page stats">
    <PageName pageName="stats" />

    <div v-for="(stats_data, type) in getStatsData" :key="type" class="stats__block">
      <div :class="`stats__diagram type-${type}`">
        <StatsRating :statsData="stats_data" />
        <StatsItems :statsData="stats_data.stats" />
        <StatsChart :statsData="stats_data.stats" :statType="type" />
      </div>

      <div class="stats__info">
        <h3>{{ $t(`stats.labels.${type}`) }}</h3>
        <InfoTooltip :tooltipName="`stats_${type}_tooltip`">
          <template v-slot:tooltip_title>{{ $t("stats.tooltip.title") }}</template>
          <p v-html="getTooltipText(type)"></p>
        </InfoTooltip>
      </div>
    </div>
  </div>
</template>

<script>
// https://ru.warface.com/minigames/battlepass/stat
import "@/assets/stats/styles/stats.styl";

import PageName from "@/components/Common/PageName";
import InfoTooltip from "@/components/Common/InfoTooltip";

import StatsRating from "./blocks/StatsRating";
import StatsItems from "./blocks/StatsItems";
import StatsChart from "./blocks/StatsChart";

import { mapGetters } from "vuex";
// import UserStats from "./UserStatsMock";

export default {
  name: "Stats",

  components: {
    PageName,
    StatsRating,
    StatsItems,
    StatsChart,
    InfoTooltip,
  },

  computed: {
    ...mapGetters("stats", ["getStatsData"]),
  },

  mounted() {
    this.$store.dispatch("stats/requestStatsData");
  },

  methods: {
    getTooltipText(type) {
      return this.$t(`stats.tooltip.${type}`);
    },
  },
};
</script>
